import { marked } from "marked";

marked.setOptions({
  gfm: true,
  breaks: true,
});

/**
 * Renders markdown to HTML. Re-parses the full buffer on each stream chunk so
 * tables and emphasis update incrementally (incomplete tokens stay literal).
 */
export function renderMarkdown(markdown = "") {
  if (!markdown) return "";
  return marked.parse(markdown);
}
